import React from 'react';
import {v4 as uuid} from 'uuid';

import {makeStyles} from '@material-ui/core/styles';

import AboutEcordum from './AboutEcordum';
import Header from './Header';

import DeviceGridItem from './DeviceGridItem';
import BlurbText from '../Custom/BlurbText';
import I18n from '../I18n';

const gridContent = [
	{
		image: '/CB11/CB11PatchAdhesive.png',
		imageAlt: `${I18n('home.CB11_patchAdhesive_alt')}`,
		logoImg: '/logos/ecordum-blue.svg',
		logoAlt: 'ecordum',
		title: `${I18n('home.CB11_title')}`,
		blurbs: [
			`${I18n('home.CB11_highlight_1')}`,
			`${I18n('home.CB11_highlight_2')}`,
			`${I18n('home.CB11_highlight_3')}`
		],
		drawingImg: '/CB11/CB11patchOnChest.svg',
		drawingAlt: 'CB11 patch on chest',
		urlPath: '/cb11-patch'
	},
	{
		image: '/CB11/CB11handheldFrontAndBack.png',
		imageAlt: `${I18n('home.CB11_img_alt')}`,
		title: `${I18n('home.CB11_subtitle')}`,
		blurbs: [
			`${I18n('home.CB11_highlight_4')}`
		],
		drawingImg: '/CB11/CB11held.svg',
		drawingAlt: 'CB11 hand held',
		urlPath: '/cb11-handheld'
	},
	{
		image: '/CB12/CB12FrontBack.png',
		imageAlt: `${I18n('home.CB12_img_alt')}`,
		logoImg: '/logos/ecordum-blue.svg',
		logoAlt: 'ecordum',
		title: `${I18n('home.CB12_title')}`,
		blurbs: [`${I18n('home.CB12_highlight_1')}`],
		drawingImg: '/CB12/CB12held.svg',
		drawingAlt: 'CB12 hand held',
		urlPath: '/cb12-handheld'
	},
	{
		image: '/devices/phones3.png',
		imageAlt: `${I18n('home.phones3_alt')}`,
		blurbs: [
			`${I18n('home.app_highlight')}`
		]
	},
	{
		image: '/devices/QTandHV_phone_screens.png',
		imageAlt: `${I18n('home.phone_screens_alt')}`,
		title: `${I18n('home.Covid19_title')}`,
		blurbs: [
			`${I18n('home.Covid19_des_01')}`,
			`${I18n('home.Covid19_des_02')}`,
			`${I18n('home.Covid19_des_03')}`
		]
	}
];

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%'
	},
	// offset: theme.mixins.toolbar,
	line: {
		height: '2px',
		borderRadius: '1px',
		background: `linear-gradient(45deg, ${theme.palette.primary.main} 5%,
		${theme.palette.secondary.main} 95%)`,
		marginBottom: '5px'
	},
	textContainer: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	fda: {
		marginTop: '15px',
		marginBottom: '10px'
	},
	cfda: {
		marginTop: '15px',
		marginBottom: '1px'
	}
}));

const HomePage = () => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<AboutEcordum />
			<Header />
			{gridContent.map((content, index) => (
				<DeviceGridItem key={uuid()} index={index} {...content} />
			))}
			<div className={classes.line} />
				<div className={classes.textContainer}>
					<BlurbText className={classes.fda}>
						<a href='https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfPMN/pmn.cfm?ID=K222842' target='_blank' color={'inherit'} rel='noopener noreferrer' style = {{textDecoration:'none'}}>
							{I18n('setting.footer1')}
						</a>
					</BlurbText>
					<BlurbText className={classes.cfda}>
						<a href='https://www.nmpa.gov.cn/datasearch/home-index.html#category=ylqx' target='_blank' color={'inherit'} rel='noopener noreferrer' style = {{textDecoration:'none'}}>
							{I18n('setting.footer2')}
						</a>
					</BlurbText>
					{/* <BlurbText className={classes.text}>OEM PCB/Module available</BlurbText> */}
				</div>
				{/* <Partners /> */}
			</div>
	);
};

export default HomePage;
